// extracted by mini-css-extract-plugin
export var contentWrapper = "footerCta-module--contentWrapper--ce19b";
export var footerCta = "footerCta-module--footerCta--e1a22";
export var headline = "footerCta-module--headline--ef789";